import { render } from "./contact-form.vue?vue&type=template&id=1c751719"
import script from "./contact-form.vue?vue&type=script&lang=js"
export * from "./contact-form.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/maskingruppen-new/maskingruppen-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__